import * as React from 'react';
import { Fragment, useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import HelpIcon from '@mui/icons-material/Help';
import logo_blanco_color from '../../../images/logo_blanco_color.png';
import logo_negro_color from '../../../images/logo_negro_color.png';
import logo_s_color from '../../../images/logo_s_color.png';
import MainMenu from '../../../components/menu/main';
import { GlobalsContext } from '../../../context/globals';
import fondoLogin from '../../../images/fondo_light.png';
import ConectionAlert from '../../conectionAlert';
import { AuthContext } from '../../../context/auth';
import UserMenu from '../../menu/user';
import NotificationBell from '../../orden/NotificationBell';
import packageJson from '../../../../package.json';
import FormularioSimpleDialog from '../../modal/formularioSimple';
import * as yup from 'yup';
import { setYupLocaleES } from '../../../const/yup';
import { useSnackbar } from 'notistack';
import { postData } from '../../../services/ajax';

setYupLocaleES();

function Copyright() {
    return (
        <Fragment>
            <Typography variant="body2" color="text.secondary" align="center">
                {'Desarrollado por el Ministerio de Salud - Chaco ' + new Date().getFullYear()}
            </Typography>

            <Typography variant="body2" color="text.secondary" align="center">
                versión {packageJson.version}
            </Typography>
        </Fragment>
    );
}

const drawerWidth = 272;

window.addEventListener('beforeunload', function (e) {
    // Cancel the event as stated by the standard.
    e.preventDefault();
    // Chrome requires returnValue to be set.
    e.returnValue = '';
});

const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        height: "100%",
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 16px',
        height: theme.spacing(7),
        flexShrink: 0,
        [theme.breakpoints.down('md')]: {
            height: theme.spacing(16),
            alignItems: "end",
        },
        ...theme.mixins.toolbar,
    },
    logo: {
        height: "100%",
        [theme.breakpoints.down('md')]: {
            height: "auto",
            width: "100%",
        },
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    appBarDrawerOpen: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    appBarDrawerMini: {
        marginLeft: theme.spacing(9),
        width: `calc(100% - ${theme.spacing(9)})`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    content: {
        flex: "1 1 auto",
        display: "flex",
        overflow: "hidden",
        flexGrow: 1,
        height: '100vh',
        paddingTop: theme.spacing(7),
        boxSizing: "border-box",
        backgroundImage: "url(" + fondoLogin + ")",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        [theme.breakpoints.up('sm')]: {
            paddingTop: theme.spacing(8),
        },
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        flex: "1 1 auto",
        height: "100%",
        overflow: "auto",
        backgroundColor: theme.palette.background.default + (theme.palette.mode === "dark" ? "EE" : "E"),
        maxWidth: "100%!important",
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },

    rightContainer: {
        display: "flex",
        alignItems: "center",
    },
    textRightContainer: {
        display: "flex",
        flexDirection: "column",
        marginRight: "8px",
        "& > *": {
            lineHeight: 1.1,
            textAlign: "right",
        },
        "& span:last-child": {
            fontSize: "0.75em",
        },
    },
    userName: {
        fontSize: ".7em!important",
    },
    userSubtitle: {
        fontSize: ".65em!important",
        marginTop: "-5px",
    },
    userSubtitleSec: {
        fontSize: ".6em!important",
        marginTop: "-5px",
    },
}));

function Layout(props) {
    const { nombrePagina } = props;
    const theme = useTheme();
    const prefersDarkMode = theme.palette.mode === "dark";
    const isMobile = useMediaQuery(theme.breakpoints.down('md')) ? true : false;
    const { classes, cx } = useStyles();
    const authContext = useContext(AuthContext);
    const usuario = authContext?.usuario || {};
    const { enqueueSnackbar } = useSnackbar();

    const globalsContext = useContext(GlobalsContext);
    const [open, setOpen] = React.useState(false);
    const [helpModalOpen, setHelpModalOpen] = React.useState(false);

    const [userMenuAnchorEl, setUserMenuAnchorEl] = React.useState(null);

    const handleDrawerOpen = () => {
        if (isMobile)
            setOpen(!open);
        else
            globalsContext.setSideOpenInDesktop(!globalsContext.sideOpenInDesktop);
    };

    const userMenuHandleClick = (event) => {
        setUserMenuAnchorEl(event.currentTarget);
    };
    const userMenuHandleClose = () => {
        setUserMenuAnchorEl(null);
    };

    const contactFormSections = React.useMemo(() => [
        {
            name: "Formulario de contacto",
            fields: [
                {
                    dataName: "nombre",
                    label: "Nombre y apellido",
                    controlType: "textField",
                    initialValue: usuario?.nombre_apellido || '',
                    validationSchema: yup.string().required("El nombre es requerido"),
                },
                {
                    dataName: "email",
                    label: "Email",
                    controlType: "textField",
                    initialValue: usuario?.email || '',
                    validationSchema: yup.string().email("Debe ser un email válido").required("El email es requerido"),
                },
                {
                    dataName: "mensaje",
                    label: "Mensaje",
                    controlType: "textField",
                    initialValue: '',
                    validationSchema: yup.string().required("El mensaje es requerido").min(10, "El mensaje debe tener al menos 10 caracteres"),
                },
            ],
        },
    ], [usuario]);

    const handleContactSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            setSubmitting(true);
            
            const response = await postData('contacto', {
                nombre: values.nombre,
                email: values.email,
                mensaje: values.mensaje,
            });

            if (response.error) {
                enqueueSnackbar(response.error || "Error al enviar el mensaje. Por favor, intenta nuevamente.", { variant: "error" });
            } else {
                enqueueSnackbar("Mensaje enviado correctamente. Nos pondremos en contacto contigo pronto.", { variant: "success" });
                setHelpModalOpen(false);
                resetForm({});
            }
        } catch (error) {
            console.error('Error al enviar formulario de contacto:', error);
            enqueueSnackbar("Error al enviar el mensaje. Por favor, intenta nuevamente.", { variant: "error" });
        } finally {
            setSubmitting(false);
        }
    };
    
    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="absolute"
                className={cx(
                    classes.appBar,
                    globalsContext.sideOpenInDesktop && !isMobile && classes.appBarDrawerOpen,
                    !globalsContext.sideOpenInDesktop && !isMobile && classes.appBarDrawerMini
                )}
                elevation={1}
            >
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={classes.menuButton}
                        size="large">
                        <MenuIcon />
                    </IconButton>

                    <Typography variant="h6" noWrap className={classes.title} sx={{
                        color: "inherit"
                    }}>
                        {nombrePagina ? nombrePagina : ""}
                    </Typography>

                    <div className={classes.rightContainer}>
                        <NotificationBell />

                        <div className={classes.textRightContainer}>
                            <Typography variant="caption" className={classes.userName} noWrap>
                                <b>{usuario?.nombre_apellido || ''}</b> 
                            </Typography>

                            <Typography variant="caption" className={classes.userSubtitleSec} noWrap>
                                {usuario?.nivel_usuario === 1 ? "Administrador" : "Operario"}
                                {usuario?.establecimiento?.nombre ? ` · ${usuario.establecimiento.nombre}` : ''}
                            </Typography>
                        </div>

                        <Tooltip title="Mi cuenta">
                            <IconButton
                                onClick={userMenuHandleClick}
                                size="small"
                                sx={{ ml: 2 }}
                                aria-controls={open ? 'account-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                            >
                                <Avatar
                                    alt={usuario.nombre}
                                    src=""//todo foto
                                    sx={{ bgcolor: theme.palette.secondary.main }}
                                />
                            </IconButton>
                        </Tooltip>
                        <UserMenu
                            anchorEl={userMenuAnchorEl}
                            onClose={userMenuHandleClose}
                            onClick={userMenuHandleClose}
                        />
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                variant={isMobile ? "temporary" : "permanent"}
                open={isMobile ? open : globalsContext.sideOpenInDesktop}
                onClose={handleDrawerOpen}
                slotProps={{
                    paper: {
                        elevation: 1,
                        className: cx(
                            classes.drawerPaper,
                            (isMobile ? !open : !globalsContext.sideOpenInDesktop) && classes.drawerPaperClose,
                        ),
                    },
                }}
            >
                <div className={classes.toolbarIcon}>
                    <img
                        className={classes.logo}
                        src={(isMobile ? open : globalsContext.sideOpenInDesktop) ?
                                (prefersDarkMode ? logo_blanco_color : logo_negro_color) :
                                logo_s_color}
                        alt="logo"
                    />
                </div>

                <Divider />

                <MainMenu />
            </Drawer>
            <main className={classes.content} >
                <Container className={classes.container} id="mainContainer">
                    {usuario && (
                        <Box sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1000 }}>
                            <Tooltip title="Ayuda y contacto">
                                <IconButton
                                    color="primary"
                                    aria-label="ayuda"
                                    onClick={() => setHelpModalOpen(true)}
                                    sx={{
                                        backgroundColor: theme.palette.primary.main,
                                        color: theme.palette.primary.contrastText,
                                        '&:hover': {
                                            backgroundColor: theme.palette.primary.dark,
                                        },
                                        boxShadow: 3,
                                    }}
                                    size="large"
                                >
                                    <HelpIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    <Grid container spacing={3}>
                        {props.children}
                    </Grid>

                    <Box sx={{
                        pt: 4
                    }}>
                        <Copyright />
                    </Box>
                </Container>
            </main>
            <ConectionAlert />
            <FormularioSimpleDialog
                open={helpModalOpen}
                setOpen={setHelpModalOpen}
                formSections={contactFormSections}
                title="Ayuda y contacto"
                description="Completa el formulario y nos pondremos en contacto contigo lo antes posible."
                cancelText="Cancelar"
                aceptText="Enviar"
                onSubmit={handleContactSubmit}
            />
        </div>
    );
}

export default Layout;